export default __webpack_public_path__ + "static/media/VE.02ff5565.svg";